import moment from 'moment';

export const OPEN360_MOVE_NOTICE_SNOOZE_DAYS = 3;
export const OPEN360_MOVE_NOTICE_SNOOZE_MS = moment.duration(OPEN360_MOVE_NOTICE_SNOOZE_DAYS, 'days').asMilliseconds();
export const OPEN360_MOVE_NOTICE_SNOOZE_KEY_PREFIX = 'open360-move-notice-snoozed';
// Sent on every event so a later wave with new copy can be told apart in PostHog.
export const OPEN360_MOVE_NOTICE_CAMPAIGN = 'november-2026-move';
export const OPEN360_MOVE_NOTICE_WHAT_CHANGES_URL = 'https://logz.io/learn/moving-to-the-new-open-360-ai-navigation/';

export const OPEN360_MOVE_NOTICE_COPY = {
  title: 'In November your account switches to Open 360 AI',
  message: 'The previous experience goes away for this account. Try Open 360 AI now so nothing surprises your team.',
  tryLabel: 'Try Open 360 AI now',
  whatChangesLabel: 'What changes',
} as const;
